import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherVM } from "@shared-kernel/application/ports/student/student-repository";

export const retrieveFavoriteTeachers = createAsyncThunk<TeacherVM[], void, { extra: Partial<Dependencies> }>(
  "teachers/retrieveFavoriteTeachers",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.favoriteTeacherList();
  },
);
